import type { ICellRendererParams } from 'ag-grid-enterprise'

import { Badge } from '@fortem-monorepo/react-ui'

import type { BalanceDisplayRow } from '../balance-drafts'

export const BalanceStatusCell = ({ value: status }: ICellRendererParams<BalanceDisplayRow, string>) => {
  if (!status) return null
  if (status === 'REVIEW REQUIRED') return <Badge theme="destructive">{status}</Badge>
  if (status === 'PENDING' || status === 'PARTIAL') return <Badge theme="warning">{status}</Badge>
  if (status === 'SAVED MANUAL') return <Badge theme="info">{status}</Badge>
  if (status === 'SAVED') return <Badge theme="success">{status}</Badge>
  return <Badge variant="outline">{status}</Badge>
}
